module.exports = __webpack_public_path__ + "static/img/6.d0debfc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/6.png
// module id = Z0sX
// module chunks = 84